import get from "lodash.get";

import { Story } from "~types/types";

const getShouldShowContextualNav = (currentStory: Story | undefined) =>
    get(currentStory, ["record"]);

export default getShouldShowContextualNav;
